<header class="fixed top-0 left-0 right-0 z-[1]">
  <div *ngIf="checkIsShowEnvIndicator()" class="absolute w-5 h-full bg-[#f8ce00] top-0 left-[0px] text-center font-medium font-NewSpirit text-black env-indicator">
    {{getEnvName()}}
  </div>
  <div class="main-header mx-auto">
    <div class="flex relative items-center justify-between">
      <div class="flex items-center justify-center mr-1 lg:mr-3">
        <a class="hidden lg:inline-block" [href]="getRouterLink()" (click)="clearExtraHistory()">
          <img *ngIf="theme !== 'Storey'" src="assets/local_logo.svg" alt="" class="w-[163px] h-[40px]">
          <img *ngIf="theme === 'Storey'" src="assets/storey_logo.png" alt="" class="w-[163px]">
        </a>
        <a class="inline-block lg:hidden min-w-[40px] mt-1" [href]="getRouterLink()">
          <img *ngIf="theme !== 'Storey'" src="assets/images/rbe_logo.svg" alt="" class="h-[40px] w-[40px]">
          <img *ngIf="theme === 'Storey'" src="assets/storey_logo.png" alt="" class="h-[40px]">
        </a>
      </div>
      <div class="text-center flex items-center">
        <app-header-search-bar (bookAnInspection)="bookAnInspection()"></app-header-search-bar>
      </div>
      <div class="flex items-center">
        <div class="flex justify-center items-center">
          <div *ngIf="!isLoggedIn" class="hidden mx-6 text-[18px] lg:flex lg:items-center">
            <a (click)="doLogin()" class="cursor-pointer">Login</a>
          </div>
          <!-- <span *ngIf="!isLoggedIn" class="material-symbols-outlined inline-block mr-2 lg:hidden cursor-pointer" (click)="menu.toggle($event)">
            account_circle
          </span> -->
          <div class="hidden lg:flex items-center mx-6 text-[18px]" *ngIf="isLoggedIn"><a (click)="logout()"
              class="cursor-pointer">Logout</a></div>
          <!-- <li class=" hidden lg:inline-block">Projects</li>
          <li class=" hidden lg:inline-block">A Local Perspective</li> -->
          <button class="hidden lg:flex w-auto btn btn-primary mr-3 btn-book-inspection" (click)="bookAnInspection()">{{'button.label.book-a-tour' | translate}}</button>
          
            
          <!-- <button class="hidden btn btn-primary lg:inline-block" (click)="openSearchPage()">Search Apartments</button> -->
          <!-- <button class="inline-block btn btn-primary lg:hidden" (click)="openSearchPage()">Search</button> -->
          <!-- <span class=" inline-block ml-2 lg:hidden material-symbols-outlined cursor-pointer" (click)="openSearchPage()">
            search
          </span> -->
          <div
            class="w-[40px] h-[40px] bg-teal lg:hidden rounded-full flex items-center justify-center ml-1 lg:ml-3 cursor-pointer"
            (click)="menu.toggle($event)">
            <span class="material-symbols-outlined text-[20px] text-white">
              menu
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="header-border">
  </div>
</header>

<p-confirmDialog></p-confirmDialog>

<p-menu #menu [model]="userMenus" [popup]="true" styleClass="w-[100px]"></p-menu>

<app-book-an-inspection [visible]="bookInspectionModalState.visible" (onSubmit)="onSubmitInspection()"
  [isNeedInspectionData]="false" [hotelOptions]="this.inspectionHotels"
  (visibleChange)="visibleChange($event)"></app-book-an-inspection>

<app-login-form [visible]="loginModalState.visible" (onClose)="onCloseLoginDialog()" [loginAction]="'Sitetour'"></app-login-form>


